import type { SettingsV1TenantSettings } from '@sdk/Api'
import { writable } from 'svelte/store'

export const tenantSettings = writable<SettingsV1TenantSettings>()

export const googleCertifiedDomainBase = writable<string>()
